<div class="pantallPath">
  {{sistemaService.pathActivo}}
</div>
